import _ from 'lodash';

import { getNodeId } from '../store/actionHandlers/common/adapterActions';

export default class TotalLeafCounter {
  constructor({ autoShow = true } = {}) {
    this._autoShow = autoShow;
  }

  get key() {
    return 'totalLeafCounter';
  }

  get autoShow() {
    return this._autoShow;
  }

  prepareTreeState(treeState) {
    treeState.leafCounters = {};
  }

  handleDidUpdateTree(treeState, { adapter, plugins }) {
    const models = _.values(treeState.models);
    this._recalculate(treeState, models, { adapter, plugins });
  }

  handleDidAddModels(treeState, models, { adapter, plugins }) {
    this._recalculate(treeState, models, { adapter, plugins });
  }

  handleWillRemoveModels(treeState, modelIdsSet, { plugins }) {
    const { filter } = plugins;
    const leafPredicat = (filter && filter.nodeIsVisible) || (() => true);
    const { parents, children } = treeState;

    const leafCounters = _.cloneDeep(treeState.leafCounters);
    const ids = Array.from(modelIdsSet);

    ids.forEach(id => {
      if (isLeaf(id) && leafPredicat(treeState, id)) {
        removeRec(parents[id], id);
      }
    });

    ids.forEach(id => {
      if (!isLeaf(id)) {
        delete leafCounters[id];
      }
    });

    function removeRec(id, leafId) {
      if (!id) {
        return;
      }
      leafCounters[id].delete(leafId);
      removeRec(parents[id], leafId);
    }

    function isLeaf(id) {
      return children[id] === undefined;
    }
  }

  _recalculate(treeState, models, { adapter, plugins }) {
    const { filter } = plugins;
    const leafPredicate = (filter && filter.nodeIsVisible) || (() => true);
    const { parents, children } = treeState;

    const leafCounters = _.cloneDeep(treeState.leafCounters);
    const ids = models.map(m => getNodeId(adapter, m));

    ids.forEach(id => {
      if (!isLeaf(id)) {
        leafCounters[id] = new Set();
      }
    });

    ids.forEach(id => {
      if (isLeaf(id) && leafPredicate(treeState, id)) {
        addRec(parents[id], id);
      }
    });

    treeState.leafCounters = leafCounters;

    function addRec(id, leafId) {
      if (!id) {
        return;
      }
      leafCounters[id] && leafCounters[id].add(leafId);
      addRec(parents[id], leafId);
    }

    function isLeaf(id) {
      return children[id] === undefined;
    }
  }

  getTotalLeafCount(treeState, nodeId) {
    return (
      (treeState.leafCounters[nodeId] && treeState.leafCounters[nodeId].size) ||
      0
    );
  }
}
